
<div class="selectContainer">
  <div class="slInputWrap">
    @if (showUnequalOption) {
      <div class="dropdownEqualOperator">
        <his-search-select-operator
          [widget]="widget"
          [isFirstInputElement]="isFirstInputElement">
        </his-search-select-operator>
      </div>
    }

    @if (showAutocomplete) {
      <his-tree-select-autocomplete
        [hisDdKey]="widget.label"
        [hisDdSearchCriterion]="true"
        [uid]="uid"
        [selectList]="selectList"
        [minLength]="minLength"
        [limit]="limit"
        [showDropdownIcon]="showDropdownIcon"
        [isFirstInputElement]="isFirstInputElement && !showUnequalOption"
        (selected)="addSelectedElement($event)">
      </his-tree-select-autocomplete>
    }
  </div>

  <his-tree-select-popup
    [title]="title"
    [treename]="treename"
    [tree]="tree"
    [selectedData]="selectedData"
    [singleSelect]="singleSelect"
    [showSubtreeSelectColumn]="showSubtreeSelectColumn"
    [isFirstInputElement]="isFirstInputElement && !showUnequalOption && !showAutocomplete"
    (selectedDataChange)="selectedDataChange($event)">
  </his-tree-select-popup>


  <div class="unsichtbar">{{'common.components.selectManyPicklist.selected' | hisUi}}:</div>
  <ng-container class="selectedOptionsList">
    @if (selectedData.length > 0) {
      <p-dataView [value]="selectedData" [emptyMessage]="'&nbsp;'" styleClass="selectedDataContainer">
        <ng-template let-selectedData #list>
          <div class="p-grid p-grid-nogutter">
            <ul>
              @for (data of selectedData; track data; let first = $first; let index = $index) {
                @if (!maxDisplayedSelections || showAllSelected || index < maxDisplayedSelections-1 || maxDisplayedSelections === selectedData.length) {
                  <li class="selectedDataRow">
                    {{data.label}}
                    @if (data.subTreeSelected) {
                      <span class="selectedData">{{data.defaulttext}}  ({{'genericSearch.tree.includeSubNodes' | hisUi}})</span>
                    }
                    @if (!(data.subTreeSelected)) {
                      <span class="selectedData">{{data.defaulttext}}</span>
                    }
                    <button type="submit" (click)="$event.stopPropagation(); deleteObj(data);" hisImage="PANEL_CLOSE" class="icon deleteSelectedOption" [title]="'view.controls.remove' | hisUi"></button>
                  </li>
                }
              }
              @if (maxDisplayedSelections && maxDisplayedSelections < selectedData.length) {
                @if (!showAllSelected) {
                  <li
                    class="selectedDataRow">
                    <button type="submit"
                      (click)="$event.stopPropagation(); toggleShowAllSelected(); $event.preventDefault();"
                      class="transparent showAllSelectedOptionsButton"
                      title="{{'common.components.selectManyPicklist.showAllSelected' | hisUi}}">
                      <span class="btnText">... {{selectedData.length - maxDisplayedSelections + 1}} {{'common.components.selectManyPicklist.more' | hisUi}}</span>
                      <img hisImage="ARROW_OUT"
                        class="inlineicon"
                        [title]="'common.components.selectManyPicklist.showAllSelected'| hisUi">
                    </button>
                  </li>
                }
                @if (showAllSelected) {
                  <li
                    class="selectedDataRow">
                    <button type="submit"
                      (click)="$event.stopPropagation(); toggleShowAllSelected(); $event.preventDefault();"
                      class="transparent showAllSelectedOptionsButton"
                      title="{{'common.components.selectManyPicklist.showLess' | hisUi}}">
                      <span class="btnText">{{'common.components.selectManyPicklist.showLess' | hisUi}}</span>
                      <img hisImage="ARROW_IN"
                        class="inlineicon"
                        [title]="'common.components.selectManyPicklist.showLess'| hisUi">
                    </button>
                  </li>
                }
              }
            </ul>
          </div>
        </ng-template>
      </p-dataView>
    }
  </ng-container>
</div>

